import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

// Figma: "Desktop - 6" (977:435) — Two ways to use SoulSathiya
// Founder (Oct 7 2026): the singles card offers both doors, matchmaking and
// the Marriage Readiness assessment; the couples card uses the one phrase the
// journey carries through to the report's cover.

const TWO_WAYS = [
  {
    image: '/two-ways-single.webp',
    label: 'Find someone who genuinely fits',
    title: 'Looking for a life partner',
    text: 'SoulSathiya matches you based on who you actually are, your personality, your values, and what you genuinely need from a long-term relationship. Not more options. Better ones. Not ready to join yet? Check your marriage readiness first.',
    ctas: [
      { cta: 'Find my match — it’s free', to: '/register', dark: true },
      { cta: 'Check my marriage readiness', to: '/v2/single', dark: false },
    ],
  },
  {
    image: '/two-ways-couple.webp',
    label: 'Understand your relationship before you decide',
    title: 'Already with someone',
    text: 'Our relationship compatibility report maps how you and your partner align across 8 psychological dimensions and where you need to be honest with each other. Takes 10 minutes.',
    ctas: [
      { cta: 'Check Couple Compatibility', to: '/couple', dark: false },
    ],
  },
];

const ctaStyle = (dark) => (dark
  ? { background: '#0e1d33', color: '#ffd666' }
  : { border: '1px solid #152c4f', color: '#152c4f' });

const TwoWaysSection = () => (
  <section className="py-14 px-6 lg:px-24" style={{ background: '#fff9ea' }}>
    <div className="flex flex-col gap-10 items-start w-full">
      <div className="flex flex-col gap-3 items-start w-full">
        <h2
          className="font-heading font-medium text-3xl sm:text-[48px] leading-[1.15] sm:leading-[56px] tracking-[-0.96px] w-full"
          style={{ color: '#0e1d33' }}
        >
          Two ways to use SoulSathiya
        </h2>
        <p className="text-lg leading-7 w-full" style={{ color: '#555555' }}>
          Depending on where you are in your journey, we have something built for you.
        </p>
      </div>

      <div className="flex flex-col md:flex-row gap-10 items-stretch w-full">
        {TWO_WAYS.map(({ image, label, title, text, ctas }) => (
          <div
            key={title}
            className="flex-1 min-w-0 rounded-3xl overflow-hidden flex flex-col"
            style={{
              background: '#fff0c7',
              border: '1px solid #f1b200',
              boxShadow: '0px 20px 40px -10px rgba(0,0,0,0.05), 0px 10px 15px -5px rgba(0,0,0,0.02)',
            }}
          >
            <div className="h-64 w-full overflow-hidden">
              <img src={image} alt={title} className="w-full h-full object-cover" loading="lazy" draggable={false} />
            </div>
            <div className="p-8 flex flex-col gap-6 flex-1 w-full">
              <div className="flex flex-col gap-1 w-full">
                <p className="text-base leading-6" style={{ color: '#152c4f' }}>{label}</p>
                <h3 className="font-heading font-bold text-[32px] leading-9" style={{ color: '#0b1729' }}>{title}</h3>
              </div>
              <p className="text-base leading-6 flex-1" style={{ color: '#555555' }}>{text}</p>
              <div className="flex flex-col gap-3 w-full">
                {ctas.map(({ cta, to, dark }) => (
                  <Link
                    key={to}
                    to={to}
                    className="flex items-center justify-center gap-1 h-14 pl-5 pr-4 py-3 rounded-xl font-medium text-base leading-6 w-full"
                    style={ctaStyle(dark)}
                  >
                    {cta} <ArrowRight className="w-5 h-5" strokeWidth={2} />
                  </Link>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TwoWaysSection;
